import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentMethodGroup } from "src/models/Prices/PaymentMethodGroup.models";

interface PaymentMethodGroupState {
  paymentMethodGroups: IPaymentMethodGroup[];
  paymentMethodGroupToEdit: IPaymentMethodGroup | null;
}

const initialState: PaymentMethodGroupState = {
  paymentMethodGroups: [],
  paymentMethodGroupToEdit: null,
};

const PaymentMethodGroupSlice = createSlice({
  name: "PaymentMethodGroup",
  initialState,
  reducers: {
    setPaymentMethodGroupList: (
      state,
      action: PayloadAction<IPaymentMethodGroup[]>
    ) => {
      state.paymentMethodGroups = action.payload;
    },
    setPaymentMethodGroupToEdit: (
      state,
      action: PayloadAction<IPaymentMethodGroup | null>
    ) => {
      state.paymentMethodGroupToEdit = action.payload;
    },
    concatListPaymentMethodGroup: (
      state: PaymentMethodGroupState,
      action: PayloadAction<IPaymentMethodGroup[]>
    ) => {
      state.paymentMethodGroups = [
        ...state.paymentMethodGroups.concat(action.payload),
      ];
    },
    addPaymentMethodGroup: (
      state,
      action: PayloadAction<IPaymentMethodGroup>
    ) => {
      state.paymentMethodGroups.push(action.payload);
    },
    updatePaymentMethodGroup: (
      state,
      action: PayloadAction<IPaymentMethodGroup>
    ) => {
      let itemIndex = state.paymentMethodGroups.findIndex(
        item =>
          item.paymentMethodGroupId === action.payload.paymentMethodGroupId
      );
      if (itemIndex !== -1)
        state.paymentMethodGroups[itemIndex] = action.payload;
    },
    deletePaymentMethodGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.paymentMethodGroups.filter(
        item => item.paymentMethodGroupId !== action.payload
      );
      state.paymentMethodGroups = newArray;
    },
  },
});

export const {
  setPaymentMethodGroupList,
  concatListPaymentMethodGroup,
  setPaymentMethodGroupToEdit,
  addPaymentMethodGroup,
  updatePaymentMethodGroup,
  deletePaymentMethodGroup,
} = PaymentMethodGroupSlice.actions;

export default PaymentMethodGroupSlice.reducer;
